import { ref } from 'vue';
import { GET_CREDIT_PACKS } from '@/queries';

export const getCreditPacks = async () => {
  try {
    const { data } = await useGraphQL(GET_CREDIT_PACKS);
    return data?.value?.data?.creditPacks?.items || [];
  } catch (error) {
    console.log('❌ Error getting credit packs', error);
    return [];
  }
};
